import {useHubQuery} from '../../QueryProvider'

/**
 * Hook to fetch the list of dismissed order change banner request IDs.
 *
 * Uses distributeduserstorage to persist dismissals per user.
 */
export const useGetDismissedOrderChangeBanners = (enabled = true) => {
  return useHubQuery('dismissedOrderChangeBanners', [], {
    enabled,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000 // 5 minutes
  })
}
